/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import * as s from './css/marquee.module.css';


const Marquee = ({ project }) => {

  const dataImages = useStaticQuery(graphql`
{
  allFile {
    edges {
      node {
        publicURL
        base
      }
    }
  }
}
`)

  const marqueeImage = dataImages.allFile.edges.find(e => e.node.base.indexOf(`marquee_${project.__influencerCode}.`) === 0);

  return (
    <div className={`full-container ${s.container}`}>
      <div className={s.containerImage} style={{ height:'100%', backgroundImage: `url(${marqueeImage.node.publicURL})`, backgroundRepeat:'repeat-x' }}>
      </div>
    </div>
  );
}

export default Marquee
